var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "large"
  }, [_vm.region.id > 0 ? _c("region", {
    attrs: {
      region: _vm.region,
      loggedUserData: _vm.loggedUserData
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };